import ChipsAutocomplete from '@superfunnel/ui-core/ChipsAutocomplete';
import { useMemo, useState } from 'react';
import { uid } from 'uid';

interface Chip {
  id: string;
  title: string;
}

interface Props {
  title?: string;
  selected: Chip[];
  setSelected?: (selected: Chip[]) => void;
  filterQuery?: (query: string) => string;
  options: Chip[];
}

export default function SettingsChipsField({
  title,
  selected,
  setSelected,
  filterQuery,
  options,
}: Props) {
  const [query, setQuery] = useState('');

  const allOptions = useMemo(() => {
    const cleanQuery = query.trim();

    const optionsAndSelected = [
      ...selected.filter((s) => !options.some((o) => o.id === s.id)),
      ...options,
    ];

    if (cleanQuery) {
      return [
        ...(optionsAndSelected.every(
          (o) => o.title.toLowerCase() !== cleanQuery.toLowerCase(),
        )
          ? [{ id: uid(8), title: cleanQuery }]
          : []),
        ...optionsAndSelected.filter((o) =>
          o.title.toLowerCase().includes(cleanQuery.toLowerCase()),
        ),
      ];
    }

    return optionsAndSelected;
  }, [options, query, selected]);

  return (
    <div className={'space-y-2'}>
      {title && (
        <h2 className="text-base-700 font-inter text-sm font-medium">
          {title}
        </h2>
      )}
      <div className="relative flex rounded-lg shadow-xs">
        <div className="w-full">
          <ChipsAutocomplete<Chip>
            getValue={(c) => c?.title}
            selected={selected}
            onChange={(s) => {
              setSelected?.(s);
            }}
            onInputChange={(t) => setQuery(t)}
            getOptionId={(t) => t.id}
            options={allOptions}
            filterQuery={filterQuery}
          />
        </div>
      </div>
    </div>
  );
}
